module.exports = __webpack_public_path__ + "static/vampire-6073020ca5389520efabb1aafbbd6034.jpg";